// // ══════════════════════════════════════════════════════
// // TIPOS DE NOTIFICAÇÕES
// // ══════════════════════════════════════════════════════

// export enum NotificationType {
//   BEFORE_DUE = 'BEFORE_DUE',
//   DUE_TODAY = 'DUE_TODAY',
//   AFTER_DUE = 'AFTER_DUE',
//   PAYMENT_CONFIRM = 'PAYMENT_CONFIRM',
// }

// export enum NotificationStatus {
//   PENDING = 'PENDING',
//   SENT = 'SENT',
//   FAILED = 'FAILED',
//   BOUNCED = 'BOUNCED',
// }

// export type NotificationChannel = 'EMAIL' | 'WHATSAPP';

// /**
//  * EmailNotificationLog
//  * Representa um email enviado ou que deveria ter sido enviado
//  */
// export interface EmailNotificationLog {
//   id: string;
//   companyId: string;
//   installmentId: string;
//   customerId: string;
//   customerName: string;
//   customerEmail: string;
//   type: NotificationType;
//   subject: string;
//   message: string;
//   status: NotificationStatus;
//   sentAt: Date | null;
//   failureReason?: string;
//   createdAt: Date;
//   updatedAt: Date;
// }

// /**
//  * WhatsappNotificationLog
//  * Representa uma mensagem WhatsApp enviada ou que deveria ter sido enviada
//  */
// export interface WhatsappNotificationLog {
//   id: string;
//   companyId: string;
//   installmentId: string;
//   customerId: string;
//   customerName: string;
//   customerPhone: string;
//   type: NotificationType;
//   message: string;
//   status: NotificationStatus;
//   sentAt: Date | null;
//   messageId?: string; // ID da mensagem no WhatsApp
//   failureReason?: string;
//   createdAt: Date;
//   updatedAt: Date;
// }



// /**
//  * Installement com informações de notificação
//  * Simulação enquanto não houver backend log real
//  */
// export interface InstallmentWithNotifications {
//   id: string;
//   orderId: string;
//   companyId: string;
//   installmentNumber: number;
//   amount: number;
//   dueDate: Date;
//   status: 'PENDING' | 'PAID' | 'OVERDUE';
//   customerId: string;
//   customerName: string;
//   customerEmail: string;
//   customerPhone: string;
  
//   // Notificações que seriam/foram enviadas
//   notifications?: {
//     email?: EmailNotificationLog[];
//     whatsapp?: WhatsappNotificationLog[];
//   };
// }

// /**
//  * Filtros para relatórios
//  */
// export interface NotificationFilters {
//   startDate?: Date;
//   endDate?: Date;
//   customerId?: string;
//   customerName?: string;
//   type?: NotificationType;
//   status?: NotificationStatus;
//   searchTerm?: string;
// }

// /**
//  * Resposta paginada
//  */
// export interface PaginatedResponse<T> {
//   data: T[];
//   total: number;
//   page: number;
//   pageSize: number;
//   totalPages: number;
// }
// ══════════════════════════════════════════════════════
// TIPOS DE NOTIFICAÇÕES
// ══════════════════════════════════════════════════════

export enum NotificationType {
  BEFORE_DUE      = 'BEFORE_DUE',
  DUE_TODAY       = 'DUE_TODAY',
  AFTER_DUE       = 'AFTER_DUE',
  PAYMENT_CONFIRM = 'PAYMENT_CONFIRM',
}

export enum NotificationStatus {
  PENDING = 'PENDING',
  SENT    = 'SENT',
  FAILED  = 'FAILED',
  BOUNCED = 'BOUNCED',
}

export type NotificationChannel = 'EMAIL' | 'WHATSAPP';

export interface EmailNotificationLog {
  id:            string;
  companyId:     string;
  installmentId: string;
  customerId:    string;
  customerName:  string;
  customerEmail: string;
  type:          NotificationType;
  subject:       string;
  message:       string;
  status:        NotificationStatus;
  sentAt:        Date | null;
  failureReason?: string;
  createdAt:     Date;
  updatedAt:     Date;
}

// export interface WhatsappNotificationLog {
//   id:           string;
//   companyId:    string;
//   customerName: string | null;
//   phone:        string;
//   message:      string;
//   type:         string | null;
//   status:       string;
//   errorMessage: string | null;
//   sentAt:       Date;
// }

export interface WhatsappNotificationLog {
  id:           string;
  companyId:    string;
  customerId?:  string;        // ← adicionado (opcional, para filtros)
  installmentId?: string;      // ← adicionado (opcional)
  customerName: string | null;
  phone:        string;
  message:      string;
  type:         NotificationType | null;  // ← era string | null
  status:       NotificationStatus;       // ← era string
  errorMessage: string | null;
  failureReason?: string;                 // ← adicionado (consistência com Email)
  sentAt:       Date | null;             // ← era Date (sem null, mas API pode retornar null)
  createdAt?:   Date;
  updatedAt?:   Date;
}


export interface InstallmentWithNotifications {
  id:                 string;
  orderId:            string;
  companyId:          string;
  installmentNumber:  number;
  amount:             number;
  dueDate:            Date;
  status:             'PENDING' | 'PAID' | 'OVERDUE';
  customerId:         string;
  customerName:       string;
  customerEmail:      string;
  customerPhone:      string;
  notifications?: {
    email?:     EmailNotificationLog[];
    whatsapp?:  WhatsappNotificationLog[];
  };
}

export interface NotificationFilters {
  startDate?:    Date;
  endDate?:      Date;
  customerId?:   string;
  customerName?: string;
  type?:         NotificationType;
  status?:       NotificationStatus;
  searchTerm?:   string;
}

export interface PaginatedResponse<T> {
  data:       T[];
  total:      number;
  page:       number;
  pageSize:   number;
  totalPages: number;
}
